<template>
  <div class="app-wrapper">
    <router-view v-if="loggedIn" />
    <router-view v-else name="default" />
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import { useRouter } from 'vue-router';
import axios from 'axios';
// ✅ Login 정적 임포트 제거 (라우터에서 동적 임포트 사용)
// 공통 스타일 및 부트스트랩, 아이콘 등 assets에서만 import
import '@/assets/styles/admin-common.css';

const router = useRouter();

function resolveContextPath(){
  const marker = '/app/';
  const path = window.location.pathname;
  const idx = path.indexOf(marker);
  return idx>0? path.substring(0, idx): '';
}
const contextPath = resolveContextPath();

const loggedIn = ref(false);

async function checkLogin(){
  try {
    await axios.post(`${contextPath}/api/auth/me`);
    loggedIn.value = true;
  } catch(e){
    loggedIn.value = false;
    if (router.currentRoute.value.name !== 'Login') {
      router.push('/auth/login');
    }
  }
}

onMounted(checkLogin);
</script>

<style>
.app-wrapper {
  min-height: 100vh;
}
</style>
